import facepaint from "facepaint";

const breakpoints: number[] = [640, 1025];
const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`));

const mqCustom = (breakpointsCustom: number[]) => {
  return facepaint(
    breakpointsCustom.map((bp) => `@media (min-width: ${bp}px)`)
  );
};

const mqMaxWidthCustom = (breakpointsChat: number[]) =>
  facepaint(breakpointsChat.map((bp) => `@media (max-width: ${bp}px)`));

export default mq;
export { mqCustom, mqMaxWidthCustom };
